module.exports = {
  encode(input, options) {
    options = options || {};
    const b64 = Buffer.from(input).toString('base64');
    return options.urlsafe ? b64.replace(/\//g, '_').replace(/\+/g, '-').replace(/=+$/, '') : b64;
  },
  decode(input, options = {}) {
    input = options.urlsafe ? input.replace(/_/g, '/').replace(/-/g, '+') : input;
    return Buffer.from(input, 'base64').toString('utf8');
  },
};
